module.exports = __webpack_public_path__ + "img/box_6.5cf4bfd2.png";